import gbLabelValueText from "./src/gb-label-value-text.vue";
const gbLabelValueTextCompenet = function(Vue) {
  Vue.component(gbLabelValueText.name, gbLabelValueText);
};
export default gbLabelValueTextCompenet;
